import React, { lazy, memo } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María Laura G.',
    quote: 'Estaba aterrada cuando me dieron los resultados. Esta guía me salvó de comer solo pollo hervido. Las recetas son riquísimas y en mi último control los valores mejoraron muchísimo.',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Carlos M.',
    quote: 'Lo mejor es que no se siente como una dieta. Mi esposa cocina para los dos usando la guía y comemos bárbaro. Me sacó el miedo a sentarme a comer.',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Silvia P.',
    quote: 'Había buscado en internet y estaba súper confundida. Chau Hígado Graso me ordenó la cabeza. La lista de compras y el menú de 7 días valen oro.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  return <section className="py-20 bg-stone-50" data-id="element-212">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center mb-16" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-215">
            Personas que ya recuperaron su tranquilidad
          </h2>
          <p className="text-lg text-stone-600" data-id="element-216">
            No estás solo en esto. Mirá cómo otros ya están mejorando.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-217">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 relative" data-id="element-218">
              <div className="flex gap-1 mb-6" data-id="element-219">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-accent-400 text-accent-400" data-id="element-220" />)}
              </div>

              <p className="text-stone-700 italic mb-8 leading-relaxed" data-id="element-221">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-222">
                <img src={t.image} alt={t.name} width={48} height={48} loading="lazy" decoding="async" className="w-12 h-12 rounded-full object-cover" data-id="element-223" />
                <div data-id="element-224">
                  <p className="font-bold text-stone-900" data-id="element-225">{t.name}</p>
                  <p className="text-sm text-brand-600 font-medium" data-id="element-226">
                    Lector Verificado
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}